<div class="menu">
    <img src="/assets/images/menu/menu.png" class="menu" style="margin-top: 2px; width: 26px; height: 26px;"
      (click)="onClose()" />
  </div>
  <div class="menu-container" #menuContainer>
    <jqxMenu #menu [theme]="environment.tema" [source]="menuAux" [mode]="'vertical'" [width]="'300px'" [height]="'100%'"
      style="border: hidden;" (onItemclick)="goToPage($event)">
    </jqxMenu>
  </div>
  